import { render } from "./FushatHub.vue?vue&type=template&id=67b66811"
import script from "./FushatHub.vue?vue&type=script&lang=js"
export * from "./FushatHub.vue?vue&type=script&lang=js"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__